import React, { forwardRef, useEffect, useRef, useImperativeHandle } from 'react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { useAppContext } from '../../providers/AppProvider';

const ReactEchart = forwardRef(({ ...rest }, ref) => {

  const chartRef = useRef(null);

  useImperativeHandle(ref, () => chartRef.current);

  const {
    config: { isFluid, isNavbarVerticalCollapsed }
  } = useAppContext();

  useEffect(() => {

    if (chartRef.current) {
      chartRef.current.resize();
    }

  }, [isFluid, isNavbarVerticalCollapsed, chartRef]);

  return <ReactEChartsCore ref={chartRef} {...rest} />;
});

export default ReactEchart;
